import Vue from 'vue'
import ProductImage from 'objects/product-image/product-image'

import withRender from './product-about.html'
import './product-about.scss'

export default withRender(Vue.extend({
  props: {
    catItem: Object,
    showAbout: { type: Boolean, default: true },
    imageSize: { type: String, default: 'L' }
  },
  components: {
    'tt-product-image': ProductImage
  }
}))
